import { get } from 'svelte/store';

import { getUnitsInfo } from 'src/services/iotu/house-management';
import { homes } from 'src/stores/account/home';
import { user_data } from 'src/stores';

export type TransferHomePrecheck = {
	homeName: string;
	sharedDevicesIn: number;
	sharedDevicesOut: number;
	sharedHomesOut: number;
	showPremium: boolean;
	cameraSlotsCount: number;
	installersCount: number;
};

/**
 * Collects informational flags for the transfer warning modal from
 * `POST /user/get_units_info`. Does not switch the active home.
 */
export async function gatherTransferHomePrecheck(unitId: string): Promise<TransferHomePrecheck> {
	const home = get(homes).list.find((entry) => entry.id === unitId && !entry.isShared);
	const fallbackName = home?.name ?? get(user_data).available_units?.[unitId] ?? unitId;

	const response = await getUnitsInfo();
	if (!response?.isok) {
		throw new Error(response?.error || 'get_units_info failed');
	}

	const unit = response.data?.own_units?.find((entry) => String(entry.unit_id) === unitId);
	const homeName = unit?.name?.trim() || fallbackName;

	return {
		homeName,
		sharedDevicesIn: unit?.devices_shared_to ?? 0,
		sharedDevicesOut: unit?.devices_shared_from ?? 0,
		sharedHomesOut: unit?.subs ?? 0,
		showPremium: Boolean(unit?.premium ?? home?.plan === 'premium'),
		cameraSlotsCount: unit?.cameras_in_slots ?? 0,
		installersCount: unit?.installers ?? 0,
	};
}
